var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":""}},[_c('dg-nav'),_c('router-view'),_c('dg-footer',{attrs:{"linkData":_vm.linkData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }